/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { css } from "@panda/css";

export const smStyles = css({
	maxWidth: `cosmos.article.sm`,
});

export const mdStyles = css({
	maxWidth: `cosmos.article.md`,
});

export const lgStyles = css({
	maxWidth: `cosmos.article.lg`,
});
